/**
 * atomberg-nearby-devices.js
 *
 * Drives the nearby Intellon devices card from the delivery check's state
 * (atomberg-delivery-state.js). The count API takes ~2 s against ~0.3 s for
 * delivery, so the count is prefetched as soon as a full pincode is typed; the
 * card is revealed only once that pincode checks serviceable with a count at
 * or above the block's minimum. Change, a not-serviceable result or an
 * out-of-stock variant hide it again.
 */
(function () {
  'use strict';

  var w = /** @type {any} */ (window);
  if (w._atombergNearbyDevicesInit) return;
  w._atombergNearbyDevicesInit = true;

  /** @param {HTMLElement} card */
  function init(card) {
    var devices = w.AtombergWqDevices;
    var state = w.AtombergDeliveryState;
    var lead = card.querySelector('[data-anb-lead]');
    if (!devices || !state || !lead) return;
    var leadEl = lead;
    var baseUrl = card.getAttribute('data-anb-base-url') || '';
    var secret = card.getAttribute('data-anb-secret') || '';
    var text = card.getAttribute('data-anb-text') || '';
    var min = parseInt(card.getAttribute('data-anb-min') || '50', 10);
    // The pincode the card may show a count for — a ~2 s count can land after Change or a newer check
    var shownFor = '';

    state.subscribe(card, function (/** @type {string} */ s, /** @type {string} */ pincode) {
      if (s === 'typed') {
        devices.getCount(pincode, baseUrl, secret);
        return;
      }
      // A variant switch re-checks the same pincode; keep the card up instead of flickering it
      if (s === 'serviceable' && pincode === shownFor && !card.hidden) return;
      card.hidden = true;
      shownFor = s === 'serviceable' ? pincode : '';
      if (!shownFor) return;
      devices.getCount(pincode, baseUrl, secret).then(function (/** @type {number} */ n) {
        if (shownFor !== pincode) return;
        // Floor is on the raw count, not the rounded one — a raw 47 floors to "40+" but is still under a 50 bar
        if (!(n >= min)) return;
        leadEl.textContent = text.replace('{count}', devices.roundCount(n).toLocaleString('en-IN'));
        card.hidden = false;
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-atomberg-nearby-devices]').forEach(function (el) {
      var card = /** @type {any} */ (el);
      if (card._anbBound) return;
      card._anbBound = true;
      init(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:load', initAll);
})();
